import type { SVGProps } from "react";
export interface Flower01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Flower01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Flower01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.874 2.874a6.825 6.825 0 0 1 8.574-.877l.553.36.552-.36.256-.161a6.825 6.825 0 0 1 8.317 1.038l.208.219a6.82 6.82 0 0 1 .83 8.099l-.16.256-.363.552.363.553.16.256a6.82 6.82 0 0 1-.83 8.1l-.208.217a6.825 6.825 0 0 1-8.317 1.037l-.256-.16-.553-.362-.552.363a6.825 6.825 0 0 1-9.451-9.451l.36-.553-.36-.552a6.825 6.825 0 0 1 .877-8.574m16.662 1.591a4.58 4.58 0 0 0-5.401-.795l-.347.206-.59.389a2.18 2.18 0 0 1-2.257.083l-.139-.083-.59-.389a4.574 4.574 0 0 0-6.336 6.336l.389.59.083.14a2.18 2.18 0 0 1 0 2.117l-.083.138-.389.59a4.576 4.576 0 0 0 6.336 6.336l.59-.388.14-.084a2.18 2.18 0 0 1 2.117 0l.138.084.59.388.348.206a4.575 4.575 0 0 0 5.4-.793l.273-.298a4.58 4.58 0 0 0 .522-5.103l-.207-.348-.388-.59a2.18 2.18 0 0 1 0-2.395l.388-.59.207-.346a4.58 4.58 0 0 0-.522-5.103z"
      />
      <path
        fill={color}
        d="M13.875 12a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m2.25 0a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
    </svg>
  );
}
